    /**
     * Initialize GSAP animations
     */
    function initGSAP() {
        if (typeof gsap !== 'undefined') {
            // Register GSAP plugins
            gsap.registerPlugin(ScrollTrigger);

            // Set up ScrollTrigger with Lenis
            if (window.lenis) {
                lenis.on('scroll', ScrollTrigger.update);

                gsap.ticker.add((time) => {
                    lenis.raf(time * 1000);
                });

                gsap.ticker.lagSmoothing(0);
            }

        }
    }

    function initGSAPLayout() {

        // Rounded corner sections
        const sectionRounded = document.querySelectorAll('.section__rounded');

        sectionRounded.forEach(section => {

            // Disable animation for screens smaller than 768px
            if (window.innerWidth < 768) {
                return;
            }

            const lockStart = section.classList.contains('lock-start');
            const lockEnd = section.classList.contains('lock-end');

            if (lockStart) {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: 'top top',
                        end: 'bottom top',
                        scrub: true,
                    }
                })
                .to(section, {
                    '--gap': '30px',
                    '--radius': '90px',
                    ease: 'none'
                }, 0);
            } else if (lockEnd) {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: 'top bottom',
                        end: 'center bottom',
                        scrub: true,
                    }
                })
                .to(section, {
                    '--gap': '0px',
                    '--radius': '60px',
                    ease: 'none'
                }, 0);
            } else {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: true,
                    }
                })
                .to(section, {
                    duration: 0.5,
                    // animate CSS variables
                    '--gap': '0px',
                    '--radius': '60px',
                    ease: 'none'
                }, 0)
                // 0.5 → 1 : return to initial state
                .to(section, {
                    duration: 0.5,
                    '--gap': '30px',
                    '--radius': '90px',
                    ease: 'none'
                }, 0.5);
            }
        });

        // Footer rounded corner sections
        const sectionFooter = document.querySelector('.section__footer');
        if (sectionFooter) {
            gsap.to(sectionFooter, {
                duration: 0.5,
                '--gap': '0px',
                '--radius': '60px',
                ease: 'none',
                scrollTrigger: {
                    trigger: sectionFooter,
                    start: 'top bottom',
                    end: 'bottom bottom',
                    scrub: true,
                }
            });
        }

        // Reveal sections
        const sectionReveal = document.querySelectorAll('.section__reveal');
        sectionReveal.forEach(section => {
            gsap.to(section, {
                y: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: section,   // when the rounded card is active
                    start: "top bottom",
                    end: "top top",
                    scrub: true
                }
            });
        });

        // Drop in sections
        const sectionDropIn = document.querySelectorAll('.section__drop-in');
        sectionDropIn.forEach(section => {
            gsap.to(section, {
                y: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: sectionDropIn,
                    start: "top bottom",
                    end: "center top",
                    scrub: true
                }
            });
        });

        // Footer GSAP
        const footerContent = document.querySelector('.content__footer-contact');
        if (footerContent) {
            gsap.to(footerContent, {
                y: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: footerContent,
                    start: "top bottom",
                    end: "center top",
                    scrub: true
                }
            });
        }

        // lenis?.on('scroll', () => ScrollTrigger.update());
        // gsap.ticker.add(t => lenis?.raf(t * 1000));
        // gsap.ticker.lagSmoothing(0);

        // Parallax for each card
        gsap.utils.toArray('.gsap__parallax').forEach(card => {
          const img = card.querySelector('.parallax-image img');
          const speed = parseFloat(card.dataset.speed || '0.2'); // tune per-card

          // amount to move: proportional to card height
          const move = () => card.clientHeight * speed;

          // set start position slightly negative so it already looks "in motion"
          gsap.set(img, { y: -move()/2 });

          ScrollTrigger.create({
            trigger: card,
            start: 'top bottom',     // when card enters viewport
            end: 'bottom top',       // until it leaves
            scrub: true,
            onUpdate: self => {
              // progress 0→1: map to -move/2 → +move/2
              const y = -move()/2 + self.progress * move();
              gsap.to(img, { y, ease: 'none', overwrite: 'auto', duration: 0 }); // immediate
            },
            // markers: true,
          });

          // Recalc on resize (card height can change)
          ScrollTrigger.addEventListener('refreshInit', () => {
            gsap.set(img, { y: -move()/2 });
          });
        });

        ScrollTrigger.refresh();

        // Stagger child elements
        const staggerChildrenContainers = document.querySelectorAll('.gsap__stagger-children');
        staggerChildrenContainers.forEach(container => {
            const items = container.querySelectorAll('.stagger-child');
            gsap.from(items, {
                opacity: 0,
                y: 30,
                duration: 1.1,
                ease: 'power2.out',
                stagger: 0.1,
                scrollTrigger: {
                    trigger: container,
                    start: "top 85%",
                    toggleActions: "play none none none",
                }
            });
        });
    }

    function initGSAPText() {

        // Heading animations
        const headingStaggerUp = document.querySelectorAll('.animated-heading__stagger-up');
        headingStaggerUp.forEach(title => {
            const wordSpans = splitWords(title);
            const wordSpeed = title.dataset.wordSpeed || 0.15;
            gsap.from(wordSpans, {
                opacity: 0,
                y: 20,
                duration: 0.6,
                ease: "power2.out",
                stagger: wordSpeed,
                scrollTrigger: {
                    trigger: title,
                    start: "top 80%",
                    toggleActions: "play none none reverse"
                }
            });
        });

        // Footer navigation animation
        const footerNavItems = gsap.utils.toArray('#footer-menu > li');
        gsap.set(footerNavItems, { y: 20, opacity: 0, willChange: 'transform, opacity' });
        gsap.to(footerNavItems, {
            y: 0,
            opacity: 1,
            duration: 0.6,
            ease: 'power2.out',
            stagger: { each: 0.12, from: 'start' },  // sequential reveal
            scrollTrigger: {
                trigger: '#footer-menu',
                start: 'top 85%',        // when the list is near the viewport
                end: 'bottom 60%',
                toggleActions: 'play none none reverse', // or keep it once: use 'play none none none'
                // markers: true,         // uncomment to debug
            }
        });

    }

    function initGSAPAnimations() {

        // Grab all elements with .gsap__fade-up
        gsap.utils.toArray('.gsap__fade-up').forEach(el => {
          gsap.from(el, {
            y: 30,
            opacity: 0,
            duration: 0.6,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: el,
              start: 'top 90%',         // play when element is 85% down the viewport
              toggleActions: 'play none none reverse',
              // once: true,            // uncomment if you want it to run only once
              // markers: true          // debug positions
            }
          });
        });

    }
